import { createCollection } from '@rocketlane/state-db';
import { RolesApi } from 'data/roles';
export const rolesCollection = createCollection({
    id: 'roles',
    getKey: (role)=>role.roleId,
    isNewer: ()=>true,
    onInsert: async ({ modified })=>{
        if (modified == null) {
            throw new Error('rolesCollection.insert: missing role payload');
        }
        return RolesApi.create({
            roleName: modified.roleName,
            type: modified.type,
            usedByPartners: modified.usedByPartners
        });
    },
    onUpdate: async ({ id, changes, original })=>{
        var _ref, _ref1, _ref2, _ref3;
        const roleId = id;
        return RolesApi.update(roleId, {
            roleName: (_ref = (_ref1 = changes === null || changes === void 0 ? void 0 : changes.roleName) !== null && _ref1 !== void 0 ? _ref1 : original === null || original === void 0 ? void 0 : original.roleName) !== null && _ref !== void 0 ? _ref : '',
            type: (_ref2 = changes === null || changes === void 0 ? void 0 : changes.type) !== null && _ref2 !== void 0 ? _ref2 : original === null || original === void 0 ? void 0 : original.type,
            usedByPartners: (_ref3 = changes === null || changes === void 0 ? void 0 : changes.usedByPartners) !== null && _ref3 !== void 0 ? _ref3 : original === null || original === void 0 ? void 0 : original.usedByPartners
        });
    },
    onDelete: async ({ id })=>{
        await RolesApi.deleteRole(id);
    }
});
